module.exports = "<div class=\"modal-body\" id=\"modal-body\">\n  \n<div class=\"row basketCreation\">\n    <div class=\"col-md-12\">\n        <div class=\"form-group\">\n            <textarea name=\"text\" class=\"form-control\" rows=\"25\">{{ $ctrl.textOfEmails}}</textarea>\n        </div>\n    </div>\n</div>\n\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.back()\">Back</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/adminMembers/adminMemberExportEmails.html
// module id = 160
// module chunks = 0